var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import { isString } from '../../utils';
import { Card as MaterialCard, CardActions, CardContent, CardMedia, Typography, } from '@material-ui/core';
import { BigProvider } from './hooks/Context';
import CardButton from './components/CardButton';
import CardContentWrapper from './components/CardContentWrapper';
const useStyles = makeStyles({
    media: {
        height: 0,
        paddingTop: '56.25%',
    },
    content: {
        textAlign: 'left',
    },
});
/**
 *
 * API:
 *
 * - [Card API](https://components-extra.netlify.app/components/card)
 * - inherits [MUI Card API](https://material-ui.com/api/card/)
 */
const Card = (_a) => {
    var { big = false, children, description, image, onClick, forwardedRef, title } = _a, rest = __rest(_a, ["big", "children", "description", "image", "onClick", "forwardedRef", "title"]);
    const classes = useStyles();
    return (React.createElement(BigProvider, { value: big },
        React.createElement(MaterialCard, Object.assign({ ref: forwardedRef }, rest),
            React.createElement(CardContentWrapper, { onClick: onClick },
                image && React.createElement(CardMedia, Object.assign({ className: classes.media }, image)),
                React.createElement(CardContent, { className: classes.content },
                    React.createElement(Typography, { gutterBottom: true, variant: big ? 'h4' : 'h5', component: "p" }, title),
                    description && (React.createElement(Typography, { component: isString(description) ? 'p' : 'div', variant: big ? 'body1' : 'body2', color: "textSecondary" }, description)))),
            children && React.createElement(CardActions, null, children))));
};
Card.propTypes = {
    big: PropTypes.bool,
    children: PropTypes.node,
    description: PropTypes.node,
    image: PropTypes.object,
    onClick: PropTypes.func,
    title: PropTypes.string.isRequired,
};
const CardExtra = styled(forwardRef((props, ref) => (React.createElement(Card, Object.assign({}, props, { forwardedRef: ref }))))) ``;
/**
 * Exposed Components
 */
CardExtra.Button = CardButton;
export default CardExtra;
